import { AgResourceLanguage } from '../types';

export const checkout: AgResourceLanguage['checkout'] = {
  summaryBlock: {
    title: {
      desktopView: 'Bestellübersicht',
      mobileView: 'Bestellübersicht'
    },
    productsOrderSummary: {
      showProduct: 'Zeigen Bestellübersicht',
      label: 'Produkte',
      hideProduct: 'Bestellübersicht Aausblenden',
      gift: 'Gratisgeschenk',
      giftPrice: 'Frei',
      shipsEvery: 'Versand alle',
      shipsOneTime: 'Einmal versendet',
      frequencyUnit: 'Tage',
      welcomeKitRemoved: `
        <p>
          Willkommen zurück!<br>
          Leider ist unser Willkommenspaket nur für Neukunden bestimmt. Brauchst du einen Ersatz? 
          Wende dich an unser Customer Happiness-Team.
        </p>
      `
    }
  },
  placeOrderFields: {
    continueButton: 'Bestellung aufgeben',
    otpCaption: `
      <p>
        Wenn du diese Bestellung aufgibst, stimmst du den 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Nutzungsbedingungen</a> und 
        der <a href="https://drinkag1.com/privacy" target="_blank" rel="noopener"> Datenschutzrichtlinie</a> zu.
      </p>
    `,
    subscriptionCaption: `
      <p>
        Wenn du diese Bestellung aufgibst, stimmst du den 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Nutzungsbedingungen</a> und 
        der <a href="https://drinkag1.com/privacy" target="_blank" rel="noopener"> Datenschutzrichtlinie</a> zu.
      </p>
      <p>
        Wenn du ein Abonnement abschließt, ermächtigst du DrinkAG1, alle 30 Tage eine beliebige Zahlungsmethode zum jeweils aktuellen Tarif zu belasten. Dein Abonnement verlängert sich automatisch, bis du es kündigst. Dies kannst du jederzeit vor dem nächsten Rechnungsdatum per E-Mail an <a href="mailto:support.eu@drinkag1.com">support.eu@drinkag1.com</a> tun.
      </p>
    `
  },
  thanksFields: {
    accountPasswordLabel: 'Passwort',
    minLength: 'Mindestens 8 Zeichen',
    maxLength: 'Password is too long (maximum is 40 characters)',
    whitespace: 'Password starts or ends with spaces',
    uppercase: '1 Großbuchstabe',
    lowercase: '1 Kleinbuchstabe',
    number: '1 Zahl',
    accountButtonLabelCreate: 'Ein Konto erstellen',
    accountButtonLabelVisit: 'Besuche Mein Konto',
    accountButtonLabelError: 'Besuche Mein Konto',
    successMessage: `
      <h1>Willkommen bei Foundational Nutrition, {{customerFirstName}}!</h1>
      <p>Die Bestätigung wurde gesendet an: {{customerEmail}}</p></div>
    `,
    errorMessage: `
      <h1>Willkommen bei AG1</h1>
      <p>Melde dich an, um dein Konto zu verwalten, Bestellungen zu verfolgen und exklusive Produkte zu kaufen.</p>
    `,
    orderDetails: `
      <p><strong>Bestellnummer:</strong> #{{orderId}}</p>
      <p><strong>Geliefert an:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    accountTitleNotCreated: `
      <h2>Ein Konto erstellen</h2>
      <p>Überprüfe den Bestellstatus, verfolge die Sendungen und vieles mehr.</p>
    `,
    accountTitleCreated: `
      <h2>Ein Konto erstellen</h2>
      <p>Überprüfe den Bestellstatus, verfolge die Sendungen und vieles mehr.</p>
    `
  },
  thanksFieldsMembers: {
    successMessage: `
      <h1>Super, deine Bestellung ist eingegangen!</h1>
      <p>Die Bestellbestätigung wurde an {{customerEmail}} geschickt.</p>
    `,
    successMessageGift: `
      <h1>Super, deine Geschenkbestellung ist bestätigt – vielen Dank!</h1>
      <p>Eine Bestellbestätigung wurde per E-Mail an {{customerEmail}} und {{giftRecipientEmail}} geschickt.<p>
    `,
    successMessageFreeGift: `
      <h1>Thanks for Sharing!</h1>
      <p>Email confirmation has been sent to: {{customerEmail}}  and {{giftRecipientEmail}}</p>
    `,
    orderDetails: `
      <p><strong>Bestellnummer:</strong> #{{orderId}}</p>
      <p><strong>Geliefert an:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    giftOrderDetails: `
      <p><strong>Order number:</strong> #{{orderId}}</p>
      <p><strong>Order type:</strong> Share Free Packs</p>
      <p><strong>Total:</strong> {{total}}</p>
      <p><strong>Delivered to:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
      <p>{{email}}</p></div>
    `,
    giftOrderDetailsPaid: `
    <p><strong>Bestellnummer:</strong> #{{orderId}}</p>
    <p><strong>Geliefert an:</strong> {{customerName}}</p>
    <p><strong>Email:</strong> {{email}}</p>
    <p>{{address}}</p></div>
    `,
    viewOrderButtonLabel: 'Bestellübersicht anzeigen',
    shareMorePacksButtonLabel: 'Share More Packs',
    giftMessageTitle: 'Gift Message:'
  },
  paymentFields: {
    paymentTitle: 'Zahlung',
    paymentReviewTitle: 'Zahlung',
    paymentReviewButton: 'Bearbeiten',
    paymentPageContinueButton: 'Rückblick Bestellung',
    creditCardLabel: 'Kreditkarte',
    creditCardReviewText: '{{brand}} , die auf {{last4}} endet',
    creditCardCustomError: 'Die Kartenangaben sind unvollständig.',
    sepaLabel: 'SEPA-Lastschrift',
    sepaReviewText: 'SEPA die auf {{name}}',
    sepaDisclaimer: `
      Hiermit ermächtige ich Athletic Greens (EU) Limited, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. 
      Im Falle eines Abonnements gilt diese Ermächtigung für wiederkehrende Zahlungen. 
      Ich weise mein Kreditinstitut an, die von Athletic Greens (EU) Limited gezogenen Lastschriften einzulösen. 
      Ich bin damit einverstanden, dass die gesetzlich vorgeschriebene Vorankündigung des Lastschrifteinzugs auf einen Tag verkürzt wird. 
      Hinweis: Ich kann innerhalb von 8 Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. 
      Es gelten die mit meinem Kreditinstitut vereinbarten Bedingungen.
    `,
    paymentPageWalletsFields: {
      deleteButton: 'Löschen',
      label: 'Zahlungsinformationen'
    },
    walletsTotalLabel: 'Gesamt'
  },
  paymentExpress: {
    title: 'Express-Kasse',
    caption: 'Oder Fortfahren, Um Mit Einer Kreditkarte Zu Bezahlen'
  },
  shippingFields: {
    subTitle: 'Lieferanschrift',
    caption: 'Deine Bestellung wird innerhalb von 3-5 Werktagen versandt.',
    email: 'E-Mail',
    countryRegion: 'Land/Region',
    firstName: 'Vorname',
    lastName: 'Nachname',
    addressLine1: 'Adresse',
    addressLine2: 'Wohnung, Zimmer usw.',
    city: 'Stadt',
    state: 'Bundesstaat',
    zipCode: 'PLZ',
    phone: 'Telefon',
    pccc: 'PCCC/Passport Number',
    isCreateAccount: `<p>Bleib dran! Du erhältst Tipps, Inspirationen und Community-News per E-Mail und wir bitten gelegentlich um dein Feedback. Du kannst dich jederzeit abmelden. Alle Details in unserer <a href="https://drinkag1.com/de-eu/privacy" target="_blank" rel="noopener">Datenschutzerklärung</a>.</p>`,
    submitButtonText: 'Weiter zur Zahlung',
    freeSubmitButtonText: 'Bestellung Überprüfen',
    reviewTitle: 'Versand',
    reviewButton: 'Bearbeiten',
    subscribeOnSms: `
      <p>
        <strong>Schicke mir eine SMS, wenn mein AG1 geliefert wird und über exklusive Gesundheits- und Wissenschaftsinhalte</strong>. 
        Ich bin damit einverstanden, automatisch generierte Marketing-SMS von DrinkAG1 an meine oben angegebene Nummer zu erhalten. 
        Das Einverständnis ist keine Bedingung für den Kauf. 
        Msg&amp;data Tarife können anfallen. Antworte mit HILFE oder STOPP, um dich abzumelden. 
        Siehe unsere <a href="https://drinkag1.com/text-message-terms" target="_blank" rel="noopener">Textnachricht Bedingungen</a>, 
        <a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Datenschutzrichtlinien</a> und 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Servicebedingungen</a>.
      </p>
    `
  },
  unifiedOrderReview: {
    backButton: 'Zurück zum Shop',
    shippingFieldsTitle: 'Lieferanschrift',
    shippingMethodSubTitle: 'Versandarten',
    frequencySubTitle: 'Lieferfrequenz',
    frequencyText: 'Alle {{frequency}}',
    frequencyUnit: 'Tage',
    paymentTitle: 'Zahlung',
    paymentSubTitle: 'Zahlung',
    billingAddressSubTitle: 'Rechnungsadresse',
    billingAddressDescription: 'Same as shipping address',
    placeOrderButton: 'Bestellung aufgeben',
    commonCaption: `
    <p>
      Wenn du ein Abonnement abschließt, ermächtigst du DrinkAG1, alle {{order_frequency_days}} Tage eine beliebige Zahlungsmethode zum jeweils aktuellen Tarif zu belasten. Dein Abonnement verlängert sich automatisch, bis du es kündigst. Dies kannst du jederzeit vor dem nächsten Rechnungsdatum per E-Mail an <a href="mailto:support@drinkag1.com">support@drinkag1.com</a> tun.
    </p>
  `,
    giftTitle: 'Send as a gift',
    giftRecipientEmailLabel: 'Recipient Email*',
    giftMessageLabel: 'Gift Message',
    shippingAddressTitle: 'Lieferadresse',
    shippingAddressText: 'Füge den Namen und die Adresse des Beschenkten hinzu'
  },
  // If Sanity does not work
  header: {
    title: 'CHECKOUT',
    editOrder: 'Reihenfolge bearbeiten'
  },
  footer: {
    links: [
      { url: 'https://drinkag1.com/privacy/de', target: true, text: 'Datenschutzbestimmungen' },
      {
        url: 'https://drinkag1.com/terms-and-conditions/de',
        target: true,
        text: 'Allgemeine Servicebedingungen'
      }
    ]
  }
};
